import React from "react";
import heroBg from "../image/image1.png";
import { href, Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const HeroHomePage = () => {
  return (
    <section
      className="relative w-full min-h-[90vh] flex items-center bg-cover bg-center"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      {/* Overlay for readability */}
      <div className="absolute inset-0 bg-white/70"></div>

      {/* Content */}
      <div className="relative z-10 w-full">
       <h3 className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8  text-center text-3xl  md:text-4xl lg:text-5xl font-bold"><span className="text-blue-900">Global Diaspora for </span><span className="text-orange-600">Public Health Dialogues</span></h3>
       
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-[36px] text-center">
          
          {/* Heading */}
         
          <h1 className="text-2xl  md:text-3xl lg:text-4xl font-serif font-bold text-blue-900 leading-tight">
           Bringing Together Public Health<br className="hidden sm:block" />
           Policy Stakeholders
          </h1>
          <h3 className="text-lg md:text-xl lg:text-2xl font-serif font-bold text-orange-600 mt-[20px]">Convergence of Excellence for Global Healthcare Systemic Resilience </h3>

          {/* Description */}
          <p className="mt-4 max-w-3xl mx-auto text-gray-700 text-base sm:text-lg">
           A healthcare strategy think tank dedicated to Policy stakeholders, Experts, and Patient & Public Advocacy Groups
          </p>

          {/* Buttons */}
          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              <HashLink smooth to="/#policy">
          <button className="bg-blue-900 text-white px-8 py-3 rounded-md font-semibold hover:bg-blue-800 transition">
            Policy Advocacy Of The Week
          </button>
        </HashLink>

            <Link to='/contact'>
            <button className="bg-orange-500 text-white px-8 py-3 rounded-md font-semibold hover:bg-orange-600 transition">
              Join the Public Health Dialogue
            </button>
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroHomePage;
